
const Table = () => import('@/../../coreui/components/ServerTable')

export default function buildMenu (allowed) {
  var routes = []
  if (allowed == null || allowed.includes('Finance') || allowed.includes('Taxes'))  {
    routes =  [
      {
        path: '/TaxInventory',
        name: 'TaxInventory',
        component: Table,
        props: {
          schema: 'sch_tax_inventory', 
          table: 'tax_inventory'
        } 
      },
      {
        path: '/TaxReceivables',
        name: 'TaxReceivables',
        component: Table,
        props: {
          schema: 'sch_tax_receivable', 
          table: 'tax_receivable'
        } 
      },
    ] 
  } 
  return routes
}
